// Roughly 19° in either direction: enough to frame the edge cards with a small buffer.
export const PROJECT_PAN_LIMIT = Math.PI * 0.155;
export const PROJECT_TOUCH_SENSITIVITY = 0.006;
